import React from 'react';
import styled, { css } from 'styled-components';

const baseStyle = css`
  font-family: ${props => props.theme.font__family};
  color: ${props => props.theme.text__color};
  max-width: 100%;
  text-align: ${props => {
    if (props.center) return 'center';
    if (props.right) return 'right';
    return 'left';
  }};
`;

const StyledParagraph = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  ${baseStyle};
`;

const StyledHeadingOne = styled.h1`
  font-size: 36px;
  line-height: 46px;
  font-weight: 300;
  ${baseStyle};
`;

const StyledHeadingTwo = styled.h2`
  font-size: 30px;
  font-weight: 300;
  line-height: 40px;
  ${baseStyle};
`;

const StyledHeadingThree = styled.h3`
  font-size: 24px;
  font-weight: 300;
  line-height: 40px;
  ${baseStyle};
`;

const StyledHeadingFour = styled.h4`
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  ${baseStyle};
`;

const StyledHeadingFive = styled.h5`
  font-size: 18px;
  font-weight: 400;
  ${baseStyle};
`;

const StyledHeadingSix = styled.h6`
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 2.4px;
  ${baseStyle};
`;

const StyledCaption = styled.p`
  font-size: 14px;
  font-weight: 400;
  ${baseStyle};
`;

const SetTypeError = styled.p`
  color: red;
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
  ${baseStyle};
`;

const Type = ({ paragraph, h1, h2, h3, h4, h5, h6, caption, right, center, ...props }) => {
  if (paragraph) return <StyledParagraph right={right} center={center} {...props} />;
  if (h1) return <StyledHeadingOne right={right} center={center} {...props} />;
  if (h2) return <StyledHeadingTwo right={right} center={center} {...props} />;
  if (h3) return <StyledHeadingThree right={right} center={center} {...props} />;
  if (h4) return <StyledHeadingFour right={right} center={center} {...props} />;
  if (h5) return <StyledHeadingFive right={right} center={center} {...props} />;
  if (h6) return <StyledHeadingSix right={right} center={center} {...props} />;
  if (caption) return <StyledCaption right={right} center={center} {...props} />;
  return <SetTypeError right={right} center={center} {...props} />;
};

export default Type;
